module.exports = __webpack_public_path__ + "img/simply-monitor.c01d54a0.png";